import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { shouldBlockPersonalQuestionnaire } from "@/helpers";

interface QuestionnaireRouteProps {
  children: React.ReactNode;
}

function QuestionnaireRoute({ children }: QuestionnaireRouteProps) {
  const { accessDecision } = useAuth();

  if (shouldBlockPersonalQuestionnaire(accessDecision)) {
    return <Navigate to="/profile" replace />;
  }

  return <>{children}</>;
}

export default QuestionnaireRoute;
